/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { FronteggUserRequest } from "../../types/FronteggUserRequest";
export const FronteggSignUpRequest = core.serialization.object({
    user: FronteggUserRequest,
});
